export class ReportingTableItem {
	id: number | null = null;
	name: string | null = null;

	constructor(data: Partial<ReportingTableItem> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}